import { Col, Form, Row } from "antd";
import { type FC, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router";

import { AddButton } from "../../../../../../../components/FeatureButtons/AddButton";
import { SelectDynamic } from "../../../../../../../components/Form/formComponents";
import { FormComponent } from "../../../../../../../components/Form/types/types";
import { canAccess } from "../../../../../../../core/router/auth/permissions";
import { ResourceName, ResourceVariant } from "../../../../../../../core/router/config/ResourceName";
import { BASE_PATH, FORM_ACTION } from "../../../../../../../core/router/types/routerTypes";

interface CardTypesSelectorProps {
    isApac?: boolean;
}

export const CardTypesSelector: FC<CardTypesSelectorProps> = ({ isApac }) => {
    const [selectedValue, setSelectedValue] = useState<string>();
    const [hasAccess, setHasAccess] = useState<boolean>(false);

    useEffect(() => {
        const checkAccess = () => {
            if (selectedValue) {
                const access = canAccess(ResourceName.APPLICATION_PROFILE_LISTS, selectedValue);
                setHasAccess(access);
            } else {
                setHasAccess(false);
            }
        };
        checkAccess();
    }, [selectedValue]);

    const fieldConfig = {
        urlToFetchOptions: isApac ? "configurations/application-profile-type-apac" : "configurations/application-profile-type-eft4f",
        optionDisplayPropName: "key",
        optionValuePropName: "value",
        name: "",
        component: FormComponent.SELECT_DYNAMIC,
        translationKeys: { label: "" },
    };

    const navigate = useNavigate();
    const { id } = useParams();
    const onAdd = () => {
        const route = isApac
            ? `${BASE_PATH}/${ResourceName.APPLICATION_PROFILE_LISTS}/${ResourceVariant.APAC}/${id}/${ResourceName.APPLICATION_PROFILE_CARD_DEFINITION_APAC}/${FORM_ACTION.CREATE}?type=${selectedValue}`
            : `${BASE_PATH}/${ResourceName.APPLICATION_PROFILE_LISTS}/${id}/${ResourceName.APPLICATION_PROFILE_CARD_DEFINITION_EFT4F}/${FORM_ACTION.CREATE}?type=${selectedValue}`;
        navigate(route);
    };

    return (
        <Row>
            <Col span={12}>
                <Form.Item>
                    <SelectDynamic
                        name="CardTypesSelector"
                        label="applicationProfileList.show.appProfiles.details"
                        fieldConfig={fieldConfig}
                        onChange={setSelectedValue}
                        value={selectedValue}
                    />
                </Form.Item>
            </Col>
            <Col offset={1} span={2}>
                <AddButton callback={onAdd} isDisabled={!selectedValue || !hasAccess} />
            </Col>
        </Row>
    );
};
